import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { PopoverCustom as Popover } from '@deprecated-ui/header';

import useAuthModalStore from 'features/securities/AuthModal/store';
import ButtonTradingFill from './ButtonTradingFill';

const InitialTradeWeb = ({ minimize, ...otherProps }) => {
  const router = useRouter();
  const showAuthModal = useAuthModalStore((state) => state.showModal);

  const activeRoutes = [
    '/securities/register/information',
    '/securities/auth',
    '/securities/login',
  ];

  const activeByDefault = activeRoutes.some((value) =>
    router.asPath.includes(value),
  );

  return (
    <Popover
      componentTrigger={(isButtonActive) => (
        <ButtonTradingFill
          {...otherProps}
          isActive={isButtonActive || activeByDefault}
          label="START TRADING"
          minimize={minimize}
          onClick={() => showAuthModal({ entryPoint: 'btn-trading' })}
        />
      )}
    />
  );
};

InitialTradeWeb.propTypes = {
  minimize: PropTypes.bool,
};

InitialTradeWeb.defaultProps = {
  minimize: true,
};

export default InitialTradeWeb;
